<template>
  <div class="w-100 mt-5">
    <div class="header">
      <div class="image-header">
        <img
          v-if="data.photo"
          class="rounded-circle"
          :src="filters.imageParse(data.photo)"
          alt="user"
        />
        <font-awesome-icon
          v-else
          icon="fa-solid fa-user"
          class="rounded-circle p-4 bg-warning"
          :style="{
            color: 'white',
          }"
        >
        </font-awesome-icon>
      </div>
      <div class="card-header">
        <CardInfo title="Buyer Name" :cardData="data.dataSeller[0]" />
      </div>
      <div class="card-header">
        <CardInfo title="Product Created" :cardData="data.dataSeller[1]" />
      </div>
      <div class="card-header">
        <CardInfo title="Total Order" :cardData="data.dataSeller[2]" />
      </div>
      <div class="card-header">
        <CardInfo title="Store Review" :cardData="data.dataSeller[3]" />
      </div>
      <button
        v-if="!isEdit"
        class="ms-auto align-self-start d-flex align-items-center btn border"
        style="background-color: #fcfcfc; width: fit-content; gap: 12px"
        @click="handleSetEdit"
      >
        <font-awesome-icon icon="fa-solid fa-pen" />
        <span> Edit Info </span>
      </button>
      <div v-else class="ms-auto d-flex flex-column" style="gap: 8px">
        <button
          class="d-flex align-items-center btn btn-danger"
          style="gap: 12px"
          @click="handleUpdate()"
        >
          <font-awesome-icon icon="fa-solid fa-check" />
          <span>Update</span>
        </button>
        <button
          class="d-flex align-items-center btn btn-outline-danger"
          style="gap: 12px"
          @click="handleDiscard"
        >
          <font-awesome-icon icon="fa-solid fa-xmark" />
          <span>Discard</span>
        </button>
      </div>
    </div>
    <div class="row w-100">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-lg-7 me-5">
            <div class="row mb-3">
              <div class="col-sm-4">
                <span class="fw-bold align-self-center">Basic Info</span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Store Name</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="isEdit ? dataEdit.fullname : data.fullname"
                  @input="dataEdit.fullname = $event.target.value"
                  :disabled="!isEdit"
                />
                <span v-if="errors.fullname" class="text-danger error-text">{{
                  errors.fullname
                }}</span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Store Email</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="isEdit ? dataEdit.email : data.email"
                  @input="dataEdit.email = $event.target.value"
                  :disabled="!isEdit"
                />
                <span v-if="errors.email" class="text-danger error-text">{{
                  errors.email
                }}</span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Whatsapp Number</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="isEdit ? dataEdit.phoneWA : data.phoneWA"
                  @input="dataEdit.phoneWA = $event.target.value"
                  :disabled="!isEdit"
                />
                <span v-if="errors.phoneWA" class="text-danger error-text">{{
                  errors.phoneWA
                }}</span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Store Phone Number</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="isEdit ? dataEdit.phoneStore : data.phoneStore"
                  @input="dataEdit.phoneStore = $event.target.value"
                  :disabled="!isEdit"
                />
                <span v-if="errors.phoneStore" class="text-danger error-text">{{
                  errors.phoneStore
                }}</span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Store Info</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="isEdit ? dataEdit.info : data.info"
                  @input="dataEdit.info = $event.target.value"
                  :disabled="!isEdit"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Banner Photo</label>
              <div class="col-sm-9">
                <img
                  :src="filters.imageParse(data.banner)"
                  class="rounded banner"
                  width="200"
                  height="80"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <p>Store Address</p>
            <div class="row">
              <p v-if="!isEdit" class="fw-bold">
                {{ data.address?.address_detail?.address_detail }}
              </p>
              <div v-else class="d-flex flex-column mb-3">
                <textarea
                  type="text"
                  class="form-control"
                  v-model="dataEdit.address.address_detail.address_detail"
                />
                <span v-if="errors.address" class="text-danger error-text">{{
                  errors.address
                }}</span>
              </div>
            </div>
            <div class="row">
              <p>Zip Code</p>
            </div>
            <div class="row">
              <p v-if="!isEdit" class="fw-bold">
                {{ data.address?.address_detail?.zip_code }}
              </p>
              <div v-else class="d-flex flex-column mb-3">
                <input
                  type="number"
                  class="form-control"
                  v-model="dataEdit.address.address_detail.zip_code"
                />
                <span v-if="errors.zip_code" class="text-danger error-text">{{
                  errors.zip_code
                }}</span>
              </div>
            </div>
            <div class="row">
              <p>Pinpoint Location</p>
            </div>
            <div class="row">
              <p class="fw-bold">
                {{ data.address?.address_detail?.lat_lng[0] }},
                {{ data.address?.address_detail?.lat_lng[1] }}
              </p>
            </div>
            <div class="mb-3 row">
              <GMapMap
                :center="data.center"
                :zoom="16"
                map-type-id="terrain"
                ref="myMapRef"
                :cluster="{ options: { styles: clusterStyle } }"
                class="map"
                :options="{
                  fullscreenControl: false,
                  styles: mapStyle,
                  mapTypeControl: false,
                  streetViewControl: false,
                  keyboardShortcuts: false,
                  controlSize: 23,
                }"
              >
                <GMapMarker
                  :key="index"
                  v-for="(m, index) in data.markers"
                  :position="m.position"
                  :icon="require(`@/assets/images/paxel-marker.svg`)"
                />
              </GMapMap>
            </div>
            <div class="d-flex flex-column mt-4" style="gap: 1rem" v-if="enableServiceType == 'true'">
              <span>Delivery Options</span>
              <div
                v-for="service in Object.values(
                  isEdit
                    ? dataEdit.availableServiceType
                    : data.availableServiceType
                )"
                class="d-flex justify-content-between rounded fw-bold p-3"
                style="background-color: #f9f9fc"
                :key="service.type"
              >
                <span class="text-capitalize">
                  {{
                    service.type?.toLowerCase() === "sameday"
                      ? "nextday"
                      : service.type?.toLowerCase()
                  }}
                </span>
                <span v-if="!isEdit">
                  {{ service.active ? "Yes" : "No" }}
                </span>
                <PopOver
                  v-else
                  :popoverStyle="{
                    backgroundColor: '#FFE9B9',
                    textAlign: 'left',
                    fontWeight: '300',
                    border: '2px solid #FFB003',
                    right: 0,
                    top: '25px',
                  }"
                >
                  <Toggle
                    :value="service.active"
                    @onChange="(val) => handleServiceAvailable(val, service)"
                  />
                  <template v-slot:text>
                    <div class="d-flex" :style="{ gap: '8px' }">
                      <img
                        :style="{
                          width: '10px',
                          height: '10px',
                          marginTop: '2px',
                        }"
                        src="@/assets/ic_info_yellow.png"
                        alt="icon-info"
                      />
                      <span
                        >At least 1 (one) Delivery option should be
                        activated</span
                      >
                    </div>
                  </template>
                </PopOver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row w-100">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-lg-6 me-5">
            <div class="d-flex align-items-center mb-3">
              <div class="d-flex me-auto">
                <div>
                  <span class="fw-bold text-start">Bank Account</span>
                </div>
                <div class="ms-3">
                  <span
                    class="badge text-success p-2"
                    style="background-color: #d1f9ed"
                    v-if="data.bankVerified"
                    >Verified</span
                  >
                  <span
                    class="badge text-danger p-2"
                    style="background-color: #fecaca"
                    v-else
                    >UnVerified</span
                  >
                </div>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Bank Account</label>
              <div class="col-sm-9">
                <input
                  v-if="!isEdit"
                  type="text"
                  class="form-control"
                  :value="isEdit ? dataEdit.bankAccount : data.bankAccount"
                  disabled
                />
                <Dropdown
                  v-else
                  showSearch
                  :showShadow="false"
                  :showIcon="false"
                  :options="bankList"
                  :value="this.dataEdit.selectedBank"
                  :containerStyle="{
                    height: '26px',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.375rem',
                    borderColor: '#ced4da',
                    fontWeight: 'normal',
                  }"
                  :contentStyle="{ top: '24px', maxHeight: '100px' }"
                  :itemStyle="{ padding: '0.375rem 0.75rem' }"
                  @onChange="(value) => (dataEdit.selectedBank = value)"
                  @onSearch="(value) => (searchBank = value)"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Bank Account Name</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="
                    isEdit ? dataEdit.bankAccountName : data.bankAccountName
                  "
                  @input="dataEdit.bankAccountName = $event.target.value"
                  :disabled="!isEdit"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Bank Account Number</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  :value="
                    isEdit ? dataEdit.bankAccountNumber : data.bankAccountNumber
                  "
                  @input="dataEdit.bankAccountNumber = $event.target.value"
                  :disabled="!isEdit"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="d-flex align-items-center mb-3">
              <span class="fw-bold fsize-20 me-auto" style="color: #5e50a1"
                >Business Hour</span
              >
            </div>
            <div
              v-for="operational in isEdit
                ? dataEdit.operationalDays
                : data.operationalDays"
              class="row"
              :key="operational.day"
            >
              <div class="col-md-6">
                <p
                  :class="[
                    'fw-bold',
                    !operational.available ? 'text-danger' : '',
                  ]"
                >
                  {{ parseDay(operational.day) }}
                </p>
              </div>
              <div class="col-md-6">
                <div class="d-flex" style="gap: 12px">
                  <span class="fw-bold" style="min-width: 40px">
                    {{ `${operational.available ? `Open` : "Closed"}` }}
                  </span>
                  <Toggle
                    v-if="isEdit"
                    :value="operational.available"
                    @onChange="(val) => (operational.available = val)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardInfo from "@/components/CardInfo.vue";
import Toggle from "@/components/Toggle.vue";
import PopOver from "@/components/PopOver.vue";
import Dropdown from "@/components/Dropdown.vue";
export default {
  components: {
    PopOver,
    CardInfo,
    Toggle,
    Dropdown,
  },
  created() {
    const listRoute = this.$route.path.split("/");
    this.id = listRoute[listRoute.length - 1];
  },
  data() {
    return {
      isEdit: false,
      mapStyle: [],
      clusterStyle: [
        {
          url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          width: 56,
          height: 56,
          textColor: "#fff",
        },
      ],
      id: "",
      searchBank: "",
      errors: {},
      //
      data: {
        availableServiceType: {},
        fullname: "",
        email: "",
        phoneWA: "",
        phoneStore: "",
        info: "",
        banner: "",
        photo: "",
        address: {},
        selectedBank: {},
        bankAccount: "",
        bankAccountName: "",
        bankAccountNumber: "",
        bankVerified: false,
        joinDate: "",
        dataSeller: [
          {
            value: "-",
            color: "red",
            url: "",
          },
          {
            value: 0,
            color: "purple",
            url: "",
          },
          {
            value: 0,
            color: "green",
            url: "",
          },
          {
            value: 0,
            color: "yellow",
            url: "",
          },
        ],
        operationalDays: [
          {
            day: "Senin",
            available: false,
            open: "",
            close: "",
          },
          {
            day: "Selasa",
            available: false,
            open: "",
            close: "",
          },
          {
            day: "Rabu",
            available: false,
            open: "",
            close: "",
          },
          {
            day: "Kamis",
            available: false,
            open: "",
            close: "",
          },
          {
            day: "Jumat",
            available: false,
            open: "",
            close: "",
          },
          {
            day: "Sabtu",
            available: false,
            open: "",
            close: "",
          },
          {
            day: "Minggu",
            available: false,
            open: "",
            close: "",
          },
        ],
        center: { lat: -6.2, lng: 106.8456 },
        markers: [
          {
            position: {
              lat: -6.2,
              lng: 106.8456,
            },
          }, // Along list of clusters
        ],
      },

      dataEdit: {
        availableServiceType: {},
        fullname: "",
        email: "",
        phoneWA: "",
        phoneStore: "",
        info: "",
        banner: "",
        photo: "",
        address: {},
        selectedBank: {},
        bankAccount: "",
        bankAccountName: "",
        bankAccountNumber: "",
        bankVerified: false,
        joinDate: "",
        dataSeller: [
          {
            value: "-",
            color: "red",
            url: "",
          },
          {
            value: 0,
            color: "purple",
            url: "",
          },
          {
            value: 0,
            color: "green",
            url: "",
          },
          {
            value: 0,
            color: "yellow",
            url: "",
          },
        ],
        operationalDays: [],
        center: { lat: -6.2, lng: 106.8456 },
        markers: [
          {
            position: {
              lat: -6.2,
              lng: 106.8456,
            },
          }, // Along list of clusters
        ],
      },
      enableServiceType: process.env.VUE_APP_ENABLE_EDIT_SERVICE_TYPE
    };
  },
  computed: {
    bankList() {
      const storeBank = this.$store.state.seller.bankList;
      const result = storeBank.map((item) => ({
        label: item.bank_name,
        value: item.bank_code,
      }));
      const regex = new RegExp(this.searchBank, "i"); // 'i' flag for case-insensitive search
      return result.filter((obj) => regex.test(obj.label));
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleValidation(data) {
      let errors = {};
      if (data.fullname.length < 5)
        errors.fullname = "Store Name minimum 5 characters";
      if (!data.fullname) errors.fullname = "Store Name cannot be empty";
      if (!this.filters.validateEmail(data.email))
        errors.email = "Invalid Email Format";
      if (!data.email) errors.email = "Email cannot be empty";
      if (!data.phoneWA) errors.phoneWA = "Whatsapp Number cannot be empty";
      if (!data.phoneStore)
        errors.phoneStore = "Store Phone Number cannot be empty";
      if (!data.address.address_detail.address_detail)
        errors.address = "Store Address cannot be empty";
      if (!data.address.address_detail.zip_code)
        errors.zip_code = "Zip Code cannot be empty";
      // turn off bank validation
      // it can be empty
      // if (!data.selectedBank.label)
      //   errors.bankAccount = "Bank Account cannot be empty";
      // if (!data.bankAccountName)
      //   errors.bankAccountName = "Bank Account Name cannot be empty";
      // if (!data.bankAccountNumber)
      //   errors.bankAccountNumber = "Bank Account Number cannot be empty";

      if (Object.keys(errors).length) {
        this.errors = errors;
        return false;
      } else {
        this.errors = {};
      }

      return true;
    },
    parseDay(string) {
      if (string == "Senin") return "Monday";
      if (string == "Selasa") return "Tuesday";
      if (string == "Rabu") return "Wednesday";
      if (string == "Kamis") return "Thursday";
      if (string == "Jumat") return "Friday";
      if (string == "Sabtu") return "Saturday";
      if (string == "Minggu") return "Sunday";
      return string;
    },
    async getData() {
      const response = await this.$store.dispatch("seller/getById", this.id);
      if (!this.bankList.length) {
        await this.$store.dispatch("seller/getBankList");
      }
      const data = response.data.data;
      this.data.fullname = data.Seller.store_name;
      this.data.joinDate = data.Seller.created_date;
      this.data.email = data.Seller.email;
      this.data.dataSeller[0].value = data.Seller.seller_name || "-";
      this.data.dataSeller[1].value = data.CountProduct;
      this.data.dataSeller[2].value = data.CountOrderSeller;
      this.data.dataSeller[3].value = data.CountReview;
      this.data.bankAccount = data.Seller.bank_info.bank_name;
      this.data.bankAccountName = data.Seller.bank_info.account_name;
      this.data.bankAccountNumber = data.Seller.bank_info.account_number;
      this.data.bankCode = data.Seller.bank_info.bank_code;
      this.data.selectedBank = {
        label: data.Seller.bank_info.bank_name,
        value: data.Seller.bank_info.bank_code,
      };
      this.data.address = data.Seller.addresses[0];
      this.data.center = {
        lat: data.Seller.addresses[0]?.address_detail.lat_lng[0],
        lng: data.Seller.addresses[0]?.address_detail.lat_lng[1],
      };

      this.data.markers = [
        {
          position: {
            lat: data.Seller.addresses[0]?.address_detail.lat_lng[0],
            lng: data.Seller.addresses[0]?.address_detail.lat_lng[1],
          },
        },
      ];

      this.data.bankVerified = data.Seller.bank_info.account_verified;
      this.data.phoneWA = data.Seller.phone_number;
      this.data.phoneStore = data.Seller.seller_phone_number;
      this.data.info = data.Seller.store_info;
      this.data.banner = data.Seller.banner_url;
      this.data.photo = data.Seller.photo_url;
      if (data.Seller.seller_operational_day) {
        this.data.operationalDays = data.Seller.seller_operational_day;
      }
      if (data.Seller.available_service_type) {
        this.data.availableServiceType = data.Seller.available_service_type;
      }
    },
    handleSetEdit() {
      // make deep copy
      const obj = { ...JSON.parse(JSON.stringify(this.data)) };
      this.dataEdit = obj;
      this.isEdit = !this.isEdit;
    },
    handleDiscard() {
      this.dataEdit = this.data;
      this.isEdit = !this.isEdit;
      this.errors = {};
    },
    handleServiceAvailable(val, service) {
      let sum = 0;
      Object.values(this.dataEdit.availableServiceType).forEach((x) => {
        if (x.active) sum++;
      });

      if ((sum <= 1 && val) || sum > 1) {
        service.active = val;
      }
    },
    async handleUpdate() {
      // TODO PERHATIKAN EDIT ADDRESS
      // ADDRESS hanya di get 1 untuk di display, jika edit address apakah akan impact ke
      // address yg lain???

      // console.log("UPDATE", {
      //   result: JSON.parse(JSON.stringify(this.dataEdit)),
      // });

      if (!this.handleValidation(this.dataEdit)) {
        // stop process if validation failed
        return;
      }

      let body = new FormData();
      body.append("store_name", this.dataEdit.fullname);
      body.append("email", this.dataEdit.email);
      body.append("store_info", this.dataEdit.info);
      body.append("seller_phone_number", this.dataEdit.phoneStore);
      body.append("phone_number", this.dataEdit.phoneWA);
      body.append(
        "address",
        this.dataEdit.address.address_detail.address_detail
      );
      body.append("zip_code", this.dataEdit.address.address_detail.zip_code);
      body.append("bank_code", this.dataEdit.selectedBank.value);
      body.append("bank_name", this.dataEdit.selectedBank.label);
      body.append("bank_account_name", this.dataEdit.bankAccountName);
      body.append("bank_account_number", this.dataEdit.bankAccountNumber);
      this.dataEdit.operationalDays?.forEach((operational) => {
        body.append("day[]", operational?.day);
        body.append("available[]", operational?.available);
        body.append("open[]", operational?.open);
        body.append("close[]", operational?.close);
      });
      this.dataEdit.availableServiceType?.forEach((service) => {
        body.append("available_service_display_name[]", service?.display_name);
        body.append("available_service_description[]", service?.description);
        body.append("available_service_type[]", service?.type?.toUpperCase());
        body.append("available_service_active[]", service?.active);
      });

      try {
        await this.$store.dispatch("seller/updateSeller", {
          id: this.id,
          body,
        });
        this.$swal({
          icon: "success",
          title: "Success Edit Seller",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.$router.push("/users/sellers");
        });
      } catch (err) {
        console.log("ERROR UPDATE SELLER", { err });
        this.$swal({
          title: err.response?.data?.errorMessage || err.message,
          icon: "warning",
          timer: 2000,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;

  .image-header {
    img {
      width: 64px;
      height: 64px;
    }
    svg {
      width: 30px;
      height: 30px;
    }
  }

  .card-header {
    flex: 1;
    max-width: 216px;
  }
}
.map {
  width: 100%;
  max-width: 550px;
  height: 150px;
}
.banner {
  object-fit: cover;
}
.error-border {
  border: 1px red solid !important;
}
</style>
